import { render } from "./HomeBottomSweiper.vue?vue&type=template&id=2cb28e54&scoped=true"
import script from "./HomeBottomSweiper.vue?vue&type=script&lang=js"
export * from "./HomeBottomSweiper.vue?vue&type=script&lang=js"

import "./HomeBottomSweiper.vue?vue&type=style&index=0&id=2cb28e54&scoped=true&lang=css"

import exportComponent from "D:\\前端\\暂存\\官网\\romenswebsite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb28e54"]])

export default __exports__